<app-sidebar></app-sidebar>
<main class="dashboard-main">
  <div class="dashboard-content">
    <div class="dashboard-header" style="display:flex; align-items:center; justify-content:space-between;">
      <div>
        <h1 class="dashboard-title">Retailers</h1>
        <div class="dashboard-welcome">Manage retail partners and their purchase limits</div>
      </div>
      <button *ngIf="userType === 'admin' || userType === 'super_admin' || userType === 'staff'" class="add-btn px-4 py-2 md:px-5 md:py-2.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors cursor-pointer font-medium text-sm md:text-base"
        (click)="openAddModal()">
        Add Retailer
      </button>
    </div>
    <hr>
    <div class="my-6 flex flex-col md:flex-row gap-3">
      <input type="text" placeholder="Search retailers..." [(ngModel)]="searchTerm" #searchBox
        (input)="onSearch(searchBox.value)"
        class="flex-1 md:w-80 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-blue-500" />
    </div>
    <div class="overflow-x-auto md:overflow-x-visible rounded-lg">
    <table class="modern-table min-w-full">
      <thead>
        <tr style="background:#f5f5f5;">
          <th>Name</th>
          <th>Email</th>
          <th>Customer Code</th>
          <th *ngIf="userType !== 'distributor'">Distributors</th>
          <th>Status</th>
          <th>Purchase Limit</th>
          <th>Total Purchases</th>
          <th>Joined</th>
          <th *ngIf="userType === 'admin' || userType === 'super_admin' || userType === 'staff'">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of retailers">
          <td>{{r.retailer_name}}</td>
          <td>{{r.email}}</td>
          <td>{{r.customer_code || '-'}}</td>
          <td *ngIf="userType !== 'distributor'">
            <div *ngIf="r.distributors && r.distributors.length > 0">
              {{r.distributors[0].distributor_name}}
              <a href="javascript:void(0)" *ngIf="r.distributors.length > 1" (click)="openLinkedDistributorsModal(r)" class="retailer-chip">
                +{{r.distributors.length - 1}}
              </a>
            </div>
            <span *ngIf="!r.distributors || r.distributors.length === 0">-</span>
          </td>
          <td>
            <span class="status" [class]="getDistributorStatusClass(r.status)">
              {{r.status | titlecase}}
            </span>
          </td>
          <td>₹{{r.purchase_limit | number}}</td>
          <td>₹{{r.total_purchases ? (r.total_purchases | number) : '0'}}</td>
          <td>{{r.created_at | date:'mediumDate'}}</td>
          <td *ngIf="userType === 'admin' || userType === 'super_admin' || userType === 'staff'">
            <span class="action-btn" *ngIf="userType === 'admin' || userType === 'super_admin' || userType === 'staff'"
              (click)="openAssignDistributorModal(r)" title="Assign Distributor">
              <i class="fas fa-link"></i>
            </span>
            <span class="action-btn"
              *ngIf="userType === 'admin' || userType === 'super_admin' || (userType === 'staff' && r.is_admin_approved === false)"
              (click)="editRetailer(r)" title="Edit">
              <i class="fas fa-edit"></i>
            </span>
            <span class="action-btn delete" *ngIf="userType === 'admin' || userType === 'super_admin'"
              (click)="deleteRetailer(r)" title="Delete">
              <i class="fas fa-trash"></i>
            </span>
          </td>
        </tr>
        <tr *ngIf="!loading && retailers.length === 0">
          <td colspan="8" style="text-align:center; padding:24px; color:#888;">No data</td>
        </tr>
        <tr *ngIf="loading">
          <td colspan="8" style="text-align:center; padding:24px; color:#888;">Loading...</td>
        </tr>
      </tbody>
    </table>
    </div>
    <div *ngIf="pagination.totalPages > 1" class="mt-6 flex flex-col sm:flex-row justify-center items-center gap-3 flex-wrap">
      <button (click)="goToPage(pagination.page - 1)" [disabled]="!pagination.hasPrev"
        class="px-3 sm:px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">Prev</button>
      <span class="text-sm text-gray-600">Page {{pagination.page}} of {{pagination.totalPages}}</span>
      <button (click)="goToPage(pagination.page + 1)" [disabled]="!pagination.hasNext"
        class="px-3 sm:px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">Next</button>
    </div>
    <app-add-retailer-modal *ngIf="showAddModal" [isEdit]="!!editingRetailerId" [retailer]="selectedRetailerData"
      (close)="closeAddModal()" (submitRetailer)="handleAddRetailer($event)">
    </app-add-retailer-modal>
    <app-assign-distributor-modal #assignModal *ngIf="showAssignModal" [retailerId]="assigningRetailerId"
      [retailerName]="assigningRetailerName" (close)="closeAssignModal()"
      (assignDistributors)="handleAssignDistributors($event)">
    </app-assign-distributor-modal>

    <app-linked-distributors-modal *ngIf="showLinkedDistributorsModal"
      [retailerId]="selectedRetailerForLinked?.id"
      [retailerName]="selectedRetailerForLinked?.retailer_name"
      (close)="closeLinkedDistributorsModal()">
    </app-linked-distributors-modal>

    <!-- Delete Confirmation Popup -->
    <div *ngIf="showDeleteConfirm" class="confirm-backdrop" (click)="cancelDelete()"></div>
    <div *ngIf="showDeleteConfirm" class="confirm-dialog">
      <div class="confirm-icon">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <h3>Delete Retailer</h3>
      <p>Are you sure you want to delete <strong>{{deletingRetailer?.retailer_name}}</strong>? This action cannot be undone.</p>
      <div class="confirm-actions">
        <button class="confirm-btn cancel" (click)="cancelDelete()" [disabled]="deleting">Cancel</button>
        <button class="confirm-btn delete" (click)="confirmDelete()" [disabled]="deleting">
          {{ deleting ? 'Deleting...' : 'Delete' }}
        </button>
      </div>
    </div>
  </div>
</main>